import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

export class ExpirationDate extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): ExpirationDate {
    return new ExpirationDate(value);
  }

  /** ラベル */
  static get label(): string {
    return '有効期限';
  }

  /** 文字列にする */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDay()}月`;
  }
}
